import { render, staticRenderFns } from "./InsMenu.vue?vue&type=template&id=367a3e79&scoped=true"
import script from "./InsMenu.vue?vue&type=script&lang=ts"
export * from "./InsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a3e79",
  null
  
)

export default component.exports